import {useRef} from 'react'
type uploadFilesprops = {
  setUploadedFiles: React.Dispatch<React.SetStateAction<File[]>>
  fileTypes: string
  labelText: string
  buttontext: string
  isMultiple: boolean
  FileUploaderror?: string | null
  setFileUploadError?: any
  forceCameraOpen?: any
}
export const UploadFiles = ({
  setUploadedFiles,
  fileTypes,
  labelText,
  buttontext,
  isMultiple,
  FileUploaderror,
  setFileUploadError,
  forceCameraOpen,
}: uploadFilesprops) => {
  const inputRef = useRef<HTMLInputElement | null>(null)
  // const [FileUploaderror, setFileUploadError] = useState<string | null>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || [])
    const validTypes = fileTypes.split(',').map((type) => type.trim())

    const invalidFiles = files.filter((file) => {
      return !validTypes.some((validType) => {
        if (validType.endsWith('/*')) {
          return file.type.startsWith(validType.slice(0, -1))
        }
        return file.type === validType
      })
    })

    if (invalidFiles.length > 0) {
      setFileUploadError('Invalid file type(s) selected. Please select valid file types.')
      setTimeout(() => {
        setFileUploadError(null);
      }, 2000);
    } else {
      setFileUploadError(null)
      setUploadedFiles((prev) => [...prev, ...files])
    }
  }

  return (
    <>
      <button
        className='btn btn-bg-primary btn-color-white'
        onClick={(e) => {
          e.stopPropagation()
          inputRef?.current?.click()
        }}
      >
        {buttontext}
      </button>
      <div>{labelText}</div>
      {FileUploaderror && <div style={{color: 'red'}}>{FileUploaderror}</div>}
      {forceCameraOpen ? (
        <input
          ref={inputRef}
          type='file'
          multiple={isMultiple}
          accept='image/*'
          capture='environment'
          onClick={(e) => {
            e.stopPropagation()
          }}
          style={{display: 'none'}}
          onChange={handleFileChange}
        />
      ) : (
        <input
          ref={inputRef}
          type='file'
          multiple={isMultiple}
          accept={fileTypes}
          onClick={(e) => {
            e.stopPropagation()
          }}
          style={{display: 'none'}}
          onChange={handleFileChange}
        />
      )}
    </>
  )
}
